export default __webpack_public_path__ + "c75b30d6ad85f6514a982fc253136044.png";